export const safe = (fn, expectedType='string', fallbackValue='-') => {
  try {
    const result = fn();
    if (expectedType === 'object') {
      if (result !== null && typeof result === 'object' && Object.prototype.toString.call(result) === '[object Object]') {
        return result;
      } else {
        //        return fallbackValue;
      }
    }
    if (typeof result !== expectedType) {
      //      return fallbackValue;
    }
    return result;
  } catch (err) {
    //    return fallbackValue; 
  }
};